export default function Logo() {
  return (
    <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_677_3168)">
        <path
          d="M21.0734 4.36263C20.2927 2.99631 19.2225 1.92912 17.8667 1.16298C16.5109 0.396837 15.0179 0.0128021 13.3898 0.0128021C11.7617 0.0128021 10.2707 0.396837 8.91295 1.16298C7.55714 1.92912 6.47934 2.99631 5.68146 4.36263C5.23016 5.13649 4.91977 5.97403 4.72363 6.86175H9.12242C9.32998 6.25 9.63656 5.71543 10.0479 5.26192C10.8781 4.34526 11.9921 3.88596 13.3898 3.88596C14.7723 3.88596 15.8767 4.34912 16.707 5.2735C17.5372 6.19789 17.9524 7.43491 17.9524 8.98649C17.9524 10.5207 17.5372 11.7519 16.707 12.686C15.8767 13.62 14.7704 14.087 13.3898 14.087C11.9921 14.087 10.8781 13.6239 10.0479 12.6995C9.64608 12.2537 9.34712 11.7288 9.13956 11.1382H4.72744C4.92358 12.0202 5.23206 12.8519 5.68146 13.6258C6.47934 15.0017 7.55714 16.0709 8.91295 16.8389C10.2707 17.6051 11.7617 17.9891 13.3898 17.9891C15.0179 17.9891 16.5071 17.6051 17.8552 16.8389C19.2034 16.0728 20.2717 15.0017 21.062 13.6258C21.8522 12.2517 22.2464 10.706 22.2464 8.98842C22.2445 7.27087 21.8541 5.72894 21.0734 4.36263Z"
          fill="white"
        />
        <path d="M4.72326 6.86176H0.505371V11.1363H4.72326V6.86176Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_677_3168">
          <rect width="21.75" height="18" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
